export default {
  NONE: 20000,
  EDITOR_IMAGE_DIALOG: 20001,
  ASSETS_DIALOG: 20002,
  FEATURE_NOT_AVAILABLE_DIALOG: 20003,
  PACKAGE_NOT_AVAILABLE_DIALOG: 20004,
};
